import {FormInstance} from 'antd/es/form';
import {createContext} from 'react';

export type TFormsFormTable = {
    form: FormInstance|null;
}

const FormsFormTableInitState = {
    form: null,
};

export const FormsFormTableContext = createContext<TFormsFormTable>(FormsFormTableInitState);
